var exports = {
  "WB": "DMWelcomeSection.module__welcomeSection___TVNPYl",
  "rZ": "DMWelcomeSection.module__profileSection___TVNPYl",
  "KI": "DMWelcomeSection.module__avatarButton___TVNPYl",
  "xO": "DMWelcomeSection.module__usernameButton___TVNPYl",
  "Xh": "DMWelcomeSection.module__username___TVNPYl",
  "Yh": "DMWelcomeSection.module__welcomeText___TVNPYl",
  "A2": "DMWelcomeSection.module__actionSection___TVNPYl",
  "I9": "DMWelcomeSection.module__mutualGuildsContainer___TVNPYl",
  "Ko": "DMWelcomeSection.module__guildIconWrapper___TVNPYl",
  "$f": "DMWelcomeSection.module__guildIcon___TVNPYl",
  "Ii": "DMWelcomeSection.module__mutualGuildsText___TVNPYl",
  "fc": "DMWelcomeSection.module__actionButtonsContainer___TVNPYl",
};

module.exports = exports;
